import { Application } from "@hotwired/stimulus"

import HeaderController from './controllers/header_controller'
import NewsletterController from './controllers/newsletter_controller'
import SearchPanelController from './controllers/searchPanel_controller'
import MobileNavController from './controllers/mobileNav_controller'
import AnnouncementBarController from './controllers/announcementBar_controller'
import CardController from './controllers/card_controller'
import ShopTheLook from './controllers/shopTheLook_controller'
import FAQController from './controllers/faq_controller'
import CartController from './controllers/cart_controller'
import CarrouselController from './controllers/carrousel_controller'
import PromosController from './controllers/promos_controller'
import CollectionController from './controllers/collection_controller'
import Transitions from './transitions'

import * as cart from '@shopify/theme-cart';

function setVhCssVar(){
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setVhCssVar()
new Transitions();

window.addEventListener('resize', function(event) {
  setVhCssVar()
}, true);

window.Stimulus = Application.start()

Stimulus.register("header", HeaderController)
Stimulus.register("newsletter", NewsletterController)
Stimulus.register("searchPanel", SearchPanelController)
Stimulus.register("mobileNav", MobileNavController)
Stimulus.register("announcementBar", AnnouncementBarController)
Stimulus.register("card", CardController)
Stimulus.register("shopTheLook", ShopTheLook)
Stimulus.register("faq", FAQController)
Stimulus.register("cart", CartController)
Stimulus.register("carrousel", CarrouselController)
Stimulus.register("promos", PromosController)
Stimulus.register("collection", CollectionController)

// cart.getState().then(state => {
//   console.log(state);
// });